import { FC } from 'react'
import { ProrithmNotification } from '../../../interfaces'
import { MenuItem, Box, Typography, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import './ProrithmNotifications.css'

interface NotificationItemProps {
  notification: ProrithmNotification
  index: number
  handleNotificationItemClick: (
    notification: ProrithmNotification,
    index: number
  ) => void
  removeNotification: (e: React.MouseEvent, index: number) => void
}

const NotificationItem: FC<NotificationItemProps> = ({
  notification,
  index,
  handleNotificationItemClick,
  removeNotification,
}) => {
  return (
    <MenuItem
      id={crypto.randomUUID()}
      className={`prorithm-notification-item ${
        notification?.isRead ? 'read' : 'unread'
      }`}
      onClick={() => handleNotificationItemClick(notification, index)}
    >
      <Box width='100%' display='flex' justifyContent='space-between'>
        <Box>
          <Typography>{notification?.messageContent?.message}</Typography>
          <Box display='flex'>
            <AccessTimeIcon fontSize='small' />
            <Typography variant='caption'>{notification?.timestamp}</Typography>
          </Box>
        </Box>
        <IconButton
          size='large'
          aria-label='remove-notification'
          onClick={(e) => {
            e.stopPropagation()
            removeNotification(e, index)
          }}
        >
          <CloseIcon className='close-icon' />
        </IconButton>
      </Box>
    </MenuItem>
  )
}

export default NotificationItem
